import { formatRequest } from "../utils/function";
import axiosInstance from "./axiosInstance";

export function createCategory(data) {
  return axiosInstance.post(`category/create`, formatRequest(data));
}

export function updateCategory(data) {
  return axiosInstance.post(`category/update`, formatRequest(data));
}

export function getCategoryList(data) {
  return axiosInstance.post(`category/list`, formatRequest(data));
}

export function getCategoryDetails(data) {
  return axiosInstance.post(`category/details`, formatRequest(data));
}

export function deleteCategory(data) {
  return axiosInstance.post(`category/delete`, formatRequest(data));
}

